import { render, staticRenderFns } from "./VehicleHighlights.vue?vue&type=template&id=e2624c1c&"
import script from "./VehicleHighlights.vue?vue&type=script&lang=js&"
export * from "./VehicleHighlights.vue?vue&type=script&lang=js&"
import style0 from "./VehicleHighlights.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports